var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStatusOther(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "144px",
    viewBox: "0 0 144 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gfx_iconStatusOther_508") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gfx_iconStatusOther_508",
    fill: "#949494",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,144 C32.235498,144 0,111.764502 0,72 C0,32.235498 32.235498,0 72,0 C111.764502,0 144,32.235498 144,72 C144,111.764502 111.764502,144 72,144 Z M72,122 C99.6142375,122 122,99.6142375 122,72 C122,44.3857625 99.6142375,22 72,22 C44.3857625,22 22,44.3857625 22,72 C22,99.6142375 44.3857625,122 72,122 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 59,
    y: 91,
    width: 26,
    height: 26,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 59,
    y: 28,
    width: 26,
    height: 57,
    rx: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusOther);
export default __webpack_public_path__ + "static/media/iconStatusOther.da12027b930509abaca6b877a6a42d7e.svg";
export { ForwardRef as ReactComponent };